import { useState, useEffect } from 'react';
import { useEnvStore } from '../../store/models';
import { SignInSignUpState } from '../../utils/constants';

/**
 * Custom hook to manage OTP dialog visibility based on sign-in/sign-up state
 * @returns {Object} Object containing showOTP state and setShowOTP setter
 */
const useOTPDialog = () => {
  const envStore = useEnvStore();
  const [showOTP, setShowOTP] = useState(false);

  const OTP_OPEN_STATES = [
    SignInSignUpState.OTP_CONFIRMATION,
    SignInSignUpState.OTP_RESEND,
    SignInSignUpState.OTP_RESENDING,
    SignInSignUpState.OTP_CONFIRMING,
  ];

  useEffect(() => {
    const shouldShowOTP = OTP_OPEN_STATES.includes(envStore.signInSignUpState.status);
    setShowOTP(shouldShowOTP);
  }, [envStore.signInSignUpState.status]);

  return {
    showOTP,
    setShowOTP,
  };
};

export default useOTPDialog;
